import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import { DateObject } from "react-multi-date-picker";

export const convertToStandardFormat = (dateString) => {
  const [time, date] = dateString.split("   ");
  const [hours, minutes, seconds] = time.split(":");
  const [year, month, day] = date.split("/");
  const standardFormat = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  const dateObject = new Date(standardFormat);
  const isoString = dateObject.toISOString();
  return isoString;
};

const now = new Date();
now.setHours(18, 0, 0, 0);

export const dateFormat = {
  date: now,
  gregorian: new DateObject({ date: now, format: "HH:mm:ss   YYYY/MM/DD" })
    .convert(gregorian, gregorian_en)
    .format(),
};
